import styled from 'styled-components';

export const LinkWrapper = styled.div`
  display: flex;
  gap: 4px;
`;
